import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	gap: "8",
});
